export default __webpack_public_path__ + "static/media/close_light.f47d6392.svg";